<template>
  <div class="title">
    奖惩情况&nbsp;
    <el-button
      v-show="!visible"
      type="primary"
      size="mini"
      plain
      style="margin-left: 50px"
      :disabled="!canEdit"
      :title="canEdit ? '' : '请取消投递后再更改简历'"
      @click="editFunc"
      >添加</el-button
    >
  </div>
  <div v-if="desertList.length === 0 && !visible" class="desc">请添加奖惩情况</div>
  <div v-show="!visible">
    <div v-for="item in desertList" :key="item.id" class="edu_item">
      <div class="left">
        <div class="part1">
          {{ item.rewardReason }}
        </div>
        <div class="part1">
          {{ formatDate('YYYY年MM月', new Date(item.rewardDate)) }}
        </div>
        <div class="part1" v-if="item.rewardOrganization || item.rewardLevel">
          <span v-if="item.rewardOrganization">{{ item.rewardOrganization }}</span>
          <span v-if="item.rewardLevel">|</span>
          <span v-if="item.rewardLevel">{{ item.rewardLevel }}</span>
        </div>
      </div>
      <div class="actions">
        <el-button type="primary" size="mini" plain @click="editFunc(item)" :disabled="!canEdit" :title="canEdit ? '' : '请取消投递后再更改简历'"
          >编辑</el-button
        >
        <el-button type="primary" size="mini" plain @click="deleteFunc(item)" :disabled="!canEdit" :title="canEdit ? '' : '请取消投递后再更改简历'"
          >删除</el-button
        >
      </div>
    </div>
  </div>
  <el-form v-show="visible" ref="formRef" :model="formData" :rules="rules" label-width="130px" class="form">
    <div v-show="false">
      <!-- 简历id -->
      <el-form-item label="basicId：" prop="basicId">
        <el-input v-model="formData.basicId" />
      </el-form-item>
      <!-- 关系id -->
      <el-form-item label="Id：" prop="id">
        <el-input v-model="formData.id" />
      </el-form-item>
    </div>
    <el-form-item :label="DESERT.rewardDate + ':'" prop="rewardDate">
      <el-date-picker v-model="formData.rewardDate" type="month" placeholder="请选择时间" style="width: 70%"></el-date-picker>
    </el-form-item>
    <el-form-item :label="DESERT.rewardReason + ':'" prop="rewardReason">
      <el-input v-model="formData.rewardReason" placeholder="请填写奖惩名称" clearable :maxlength="30" style="width: 70%" />
    </el-form-item>
    <el-form-item label="奖惩机构：" prop="rewardOrganization">
      <el-input v-model="formData.rewardOrganization" placeholder="请填写奖惩机构" clearable :maxlength="30" style="width: 70%" />
    </el-form-item>
    <el-form-item label="奖惩级别：" prop="rewardLevel">
      <el-input v-model="formData.rewardLevel" placeholder="请填写奖惩级别" clearable :maxlength="30" style="width: 70%" />
    </el-form-item>
    <el-form-item class="submit" label-width="0">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="onReset">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { reactive, watch, onMounted, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import ApplicantApi from '../../service/api/applicant';
import { formatDate } from '../../utils/tools';
import { ElMessage } from 'element-plus';
import { DESERT } from '../../utils/resume';

export default {
  name: 'Desert',
  components: {},
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['callback', 'update:modelValue'],
  setup(props, context) {
    const state = reactive({
      desertList: [],
      visible: false,
      formRef: null,
      formData: {},
      rules: {
        rewardDate: [{ required: true, message: DESERT.rewardDate + '必填', trigger: 'change' }],
        rewardReason: [{ required: true, message: DESERT.rewardReason + '必填', trigger: 'change' }],
      },
    });
    watch(
      () => props.modelValue,
      () => {
        state.desertList = props.modelValue.cvDesertList || [];
      },
    );

    const editFunc = (item) => {
      if (!props.modelValue.id) {
        return ElMessage.warning('请先填写基本信息');
      }
      if (!item) {
        state.formData = { basicId: props.modelValue.id };
      } else {
        state.formData = { ...item, basicId: props.modelValue.id };
      }
      state.visible = true;
    };
    const deleteFunc = async (item) => {
      try {
        await ApplicantApi.deleteResumeDesert(item.id);
        context.emit('callback');
        ElMessage.success('删除成功');
      } catch (e) {
        console.error(e);
      }
    };

    const onSubmit = () => {
      state.formRef.validate(async (valid) => {
        if (valid) {
          const formData = { ...state.formData };
          Object.entries(formData).forEach(([key, value]) => {
            if (value instanceof Date) {
              formData[key] = formatDate('YYYY-MM-DD', value);
            }
          });
          try {
            if (formData.id) {
              await ApplicantApi.updateResumeDesert([formData]);
            } else {
              delete formData.id;
              await ApplicantApi.addResumeDesert([formData]);
            }
            ElMessage.success('保存成功');
            context.emit('callback');
            state.formRef.resetFields();
            state.visible = false;
          } catch (e) {
            console.error(e);
          }
        } else {
          return false;
        }
      });
    };
    const onReset = () => {
      state.visible = false;
      state.formRef.resetFields();
    };

    onMounted(() => {});
    return {
      router: useRouter(),
      ...toRefs(state),
      onSubmit,
      onReset,
      editFunc,
      deleteFunc,
      formatDate,
      DESERT,
    };
  },
};
</script>

<style scoped lang="scss">
.title {
  color: #000;
  font-size: 20px;
  padding: 30px 20px 10px;
  font-weight: 600;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background: #409eff;
    left: 8px;
    top: 36px;
  }
}
.desc {
  padding-left: 30px;
  font-size: 14px;
  margin: 7px 0 20px;
  color: #606266;
}
.edu_item {
  display: flex;
  align-items: center;
  padding: 20px;
  &:hover {
    box-shadow: 0 0 4px 0 rgb(0 0 0 / 30%);
    border-radius: 4px;
  }
  .left {
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 22px;
    .part1 {
      margin-right: 22px;
    }
  }
  .actions {
    text-align: right;
  }
}
.form {
  position: relative;
}
.submit {
  margin-top: 30px;
  text-align: center;
}
</style>
